import { render, staticRenderFns } from "./order-management.vue?vue&type=template&id=2e2d7d1d&scoped=true&"
import script from "./order-management.vue?vue&type=script&lang=js&"
export * from "./order-management.vue?vue&type=script&lang=js&"
import style0 from "./order-management.vue?vue&type=style&index=0&id=2e2d7d1d&prod&lang=less&scoped=true&"
import style1 from "./order-management.vue?vue&type=style&index=1&id=2e2d7d1d&prod&lang=less&"
import style2 from "./order-management.vue?vue&type=style&index=2&id=2e2d7d1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d7d1d",
  null
  
)

export default component.exports